import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../services/authentication.service';
import { FirestoreService } from '../../services/firestore.service';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-people-details',
  templateUrl: './people-details.component.html',
  styleUrls: ['./people-details.component.sass']
})
export class PeopleDetailsComponent implements OnInit {
  uid;
  signinPeople;
  peopleDocId;
  peopleDoc;
  coverPicture: string = "./assets/img/no-cover.png";
  profilePicture: string = "./assets/img/no-people.png";
  businessProfilePicture: string = "./assets/img/no-logo.png";
  profilePictureCol;
  coverPictureCol;
  //email: string = 'moses@pngl.com';
  updatePeopleForm;
  profilePictureColDocLenght;
  coverPictureColDocLenght;

  // Upload Picture File
  pictureUpload;
  activeProfilePictureUrl;
  uploadProgress: number = 0;

  //Business Page
  businessDocLength;
  businessColOwned;
  businessCategoryCol;
  addBusinessForm: FormGroup;
  
  constructor(
    private fb : FormBuilder,
    public db: FirestoreService,
    public auth: AuthenticationService,
    public storage: StorageService,
    public afAuth: AngularFireAuth,
    public afDd: AngularFirestore,
    public route: Router,
    public aRoute: ActivatedRoute,
    private modalService: NgbModal,
    config: NgbModalConfig,
    ) {}

  ngOnInit(): void {
    this.auth.getPeopleSignInUid()
    .then( res=> {
      this.uid = res.uid;     
      this.profilePictureCol = this.db.getSubColLimit(10, 'people', this.uid, 'profilePictures');
      this.coverPictureCol = this.db.getSubColLimit(10, 'people', this.uid, 'coverPictures');
      this.businessColOwned = this.db.getMainColWhereArrayContains('governments', 'pageAdmins', this.uid);
      // this.db.getSubColDocLenght('people', this.uid, 'profilePictures')
      // .snapshotChanges()
      // .subscribe(query=>{
      // this.profilePictureColDocLenght = query.length;
      // });
      // this.db.getSubColDocLenght('people', this.uid, 'coverPictures')
      // .snapshotChanges()
      // .subscribe(query=>{
      // this.coverPictureColDocLenght = query.length;
      // });
      this.db.getMainColDocLenght('businesses', 'owners', this.uid)
      .snapshotChanges()
      .subscribe(query=>{
      this.businessDocLength = query.length;
      console.log('this.businessDocLength: '+this.businessDocLength);
      
      });
    })
    .then( res=> {
      this.peopleDoc = this.db.getPeopleDetails(this.uid);
    });

    this.businessCategoryCol = this.db.getMainCol('businessCategories');

    this.updatePeopleForm = this.fb.group({
      nameFirst:'',
      nameLast: '',
      dateUpdated: Date.now(),
    })  
    
    this.addBusinessForm = this.fb.group({
      name: '',
      category: '',
      about: '',
      phone: '',
      email: '',
      websiteUrl: '',
      postal: '',
      socialFacebookUrl:'',
      socialLinkedinUrl:'',
      colId: 'businesses',
      dateUpdated: Date.now(),
      dateCreated: Date.now(),
      publish: false,
      popular: false,
    });
 }

 ngAfterViewInit(){
  
 }

  //Business Page
  closeAddBusinessModalForm(){
    this.modalService.dismissAll()
    this.addBusinessForm.reset()
  }
  openAddBusinessModalForm(content) {
    this.modalService.open(content);
  }
  addBusinessDoc(formValues) {
    this.db.addMainBusinessDoc(formValues, 'businesses', this.uid)
    .then(res =>{
     this.closeAddBusinessModalForm()
   })
  }
  
  reloadComponent() {
    let currentUrl = this.route.url;
    this.route.routeReuseStrategy.shouldReuseRoute = () => false;
    this.route.onSameUrlNavigation = 'reload';
    this.route.navigate([currentUrl]);
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth'
    });
  }

  openSpinnerModal(content){
    this.modalService.open(content);
    setTimeout(() => {
      this.modalService.dismissAll();
    }, 5000);
  }

  // Profile Picture
  addProfilePictureDoc(e, spinnerModalContent){
    this.pictureUpload = e.target.files[0]
    if(this.pictureUpload != undefined){
      // Open Modal
      this.modalService.open(spinnerModalContent); 
      this.storage.uploadFileSubSubFolderSubCol(this.pictureUpload, 'profilePictureUrl', 'pictureUrl','people', this.uid, 'profilePictures')
      .subscribe(progress =>{
        this.uploadProgress = progress
        // Close Modal
        if(this.uploadProgress == 100){
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 3000);
        }
      })
    }
  }
  updateProfilePictureDoc(pictureUrl){
    this.db.updateMainDocField('people', this.uid, 'profilePictureUrl', pictureUrl)
    .then(res =>{
      this.reloadComponent();
    })
  }
  deleteProfilePictureDoc(docid, pictureUrl){
    this.storage.deleteFile(pictureUrl)
    .then(res =>{
      this.db.deleteSubDoc('people', this.uid, 'profilePictures', docid)
    })
  }
  // Cover Picture
  addCoverPictureDoc(e, spinnerModalContent){
    this.pictureUpload = e.target.files[0];
    if(this.pictureUpload != undefined){
      // Open Modal
      this.modalService.open(spinnerModalContent); 
      this.storage.uploadFileSubSubFolderSubCol(this.pictureUpload, 'coverPictureUrl','pictureUrl' ,'people', this.uid, 'coverPictures')
      .subscribe(progress =>{
        this.uploadProgress = progress
        // Close Modal
        if(this.uploadProgress == 100){
          setTimeout(() => {
            this.modalService.dismissAll();
          }, 3000);
        }
      })
    }
  }
  updateCoverPictureDoc(pictureUrl){
    this.db.updateMainDocField('people', this.uid, 'coverPictureUrl', pictureUrl)
    .then(res =>{
      this.reloadComponent();
    })
  }
  deleteCoverPictureDoc(docid, pictureUrl){
    this.storage.deleteFile(pictureUrl)
    .then(res =>{
      this.db.deleteSubDoc('people', this.uid, 'coverPictures', docid)
    })
  }

  // Update People details
  closeUpdatePeopleModalForm(){
    this.modalService.dismissAll()
    this.updatePeopleForm.reset()
    this.updatePeopleForm.patchValue({ // Set the dateUpdated field value
      dateUpdated: Date.now()
    });
  }
  openUpdatePeopleModalForm(content) {
    this.modalService.open(content);
    //this.peopleDoc = this.db.getPeopleDoc(this.peopleDocId);
  }
  updatePeopleDoc(formValues){
    this.db.updatePeopleDetails(formValues, this.uid)
    .then(res =>{
      this.closeUpdatePeopleModalForm();
      console.log(formValues);
      
    })
  }

  // Confirm Sign Out
  closeConfirmSignOutModal(){
    this.modalService.dismissAll();
  }
  openConfirmSignOutModal(content) {
    this.modalService.open(content);
  }
  peopleSignOut(){
    this.auth.doLogout();
    this.closeConfirmSignOutModal();
  }

  // Delete People
  deletePeople(){
    //this.db.deletePeople(this.uid);
  }

  // route
  routeToHomePage(){
    this.route.navigate(['']);
  }
  routeToPeopleDetailsUpdatePage(){
    this.route.navigate(['people/update/details']);
  }

  routeToBusinessDetailPage(docId){
    this.route.navigateByUrl('admin/business/'+docId);
  };
  routeToGovernmentDetailPage(docId){
    this.route.navigateByUrl('admin/government/'+docId);
  };
}